import { Component, createElement } from 'react';
import { PaymentCard } from '@mews-framework/payments/cards';

export default function paymentCardExpiryFactory(
    inputElement: React.ComponentType<unknown & React.InputHTMLAttributes<HTMLInputElement>>
) {
    return class PaymentCardExpiry extends Component<React.InputHTMLAttributes<HTMLInputElement>> {
        restrictExpiry = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) {
                return;
            }

            if (PaymentCard.hasTextSelected(target)) {
                return;
            }

            let value = target.value + digit;
            value = value.replace(/\D/g, '');
            if (value.length > 6) {
                e.preventDefault();
            }
        };

        reFormatExpiry = (e: React.KeyboardEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            window.setTimeout(() => {
                target.value = PaymentCard.formatExpiry(target.value);
            }, 0);
        };

        formatExpiry = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) {
                return;
            }

            const val = target.value + digit;
            if (/^\d$/.test(val) && val !== '0' && val !== '1') {
                e.preventDefault();
                window.setTimeout(() => {
                    target.value = '0' + val + ' / ';
                }, 0);
            } else if (/^\d\d$/.test(val)) {
                e.preventDefault();
                window.setTimeout(() => {
                    target.value = '' + val + ' / ';
                }, 0);
            }
        };

        formatForwardExpiry = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) {
                return;
            }

            const val = target.value;
            if (/^\d\d$/.test(val)) {
                target.value = '' + val + ' / ';
            }
        };

        formatForwardSlashAndSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const which = String.fromCharCode(e.which);
            if (!(which === '/' || which === ' ')) {
                return;
            }

            const val = target.value;
            if (/^\d$/.test(val) && val !== '0') {
                target.value = '0' + val + ' / ';
            }
        };

        formatBackExpiry = (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const { value } = target;

            if (e.which !== 8) {
                return;
            }
            if (target.selectionStart !== null && target.selectionStart !== value.length) {
                return;
            }

            if (/\d\s\/\s$/.test(value)) {
                e.preventDefault();
                window.setTimeout(() => {
                    target.value = value.replace(/\d\s\/\s$/, '');
                }, 0);
            }
        };

        render() {
            const { onKeyPress, onChange, onInput, ...other } = this.props;

            const props = {
                onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
                    e.persist();
                    PaymentCard.restrictNumeric(e);
                    this.restrictExpiry(e);
                    if (onKeyPress) {
                        onKeyPress(e);
                    }
                },
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    e.persist();
                    this.reFormatExpiry(e);
                    window.setTimeout(() => {
                        if (onChange) {
                            onChange(e);
                        }
                    }, 0);
                },
                onInput: (e: React.KeyboardEvent<HTMLInputElement>) => {
                    e.persist();
                    this.reFormatExpiry(e);
                    window.setTimeout(() => {
                        if (onInput) {
                            onInput(e);
                        }
                    }, 0);
                },
            };

            const Input = createElement(inputElement, {
                ...props,
                ...other,
                type: 'tel',
            });
            return Input;
        }
    };
}
